import React, { useState, useImperativeHandle, forwardRef } from "react";

const MultiSelectEditor = forwardRef((props, ref) => {
  const { value, colDef, api, node, column } = props;
  const options = colDef?.cellEditorParams?.options || [];
  const initial = Array.isArray(value) ? value : [];
  const [selected, setSelected] = useState(initial);

  const toggle = (opt) => {
    setSelected((prev) =>
      prev.includes(opt) ? prev.filter((v) => v !== opt) : [...prev, opt]
    );
  };

  useImperativeHandle(ref, () => ({
    getValue: () => selected.slice().sort((a, b) => a.localeCompare(b)),
    isPopup: () => true,
  }));

  const commitValue = () => {
    try {
      const colId = column?.getColId?.();
      if (node && colId) {
        const sorted = selected.slice().sort((a, b) => a.localeCompare(b));
        node.setDataValue(colId, sorted);
      }
    } catch {}
  };

  const onOk = () => {
    commitValue();
    api?.stopEditing();
  };
  const onCancel = () => api?.stopEditing(true);

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onOk();
    } else if (e.key === "Escape") {
      e.preventDefault();
      onCancel();
    }
  };

  return (
    <div
      className="bg-white border border-slate-300 rounded shadow p-2 max-h-72 w-64 overflow-auto"
      onKeyDown={onKeyDown}
      tabIndex={0}
    >
      <div className="space-y-1">
        {options.map((opt) => (
          <label
            key={opt}
            className="flex items-center gap-2 py-1 px-1 text-sm"
          >
            <input
              type="checkbox"
              className="h-4 w-4"
              checked={selected.includes(opt)}
              onChange={() => toggle(opt)}
            />
            <span>{opt}</span>
          </label>
        ))}
      </div>
      <div className="flex justify-end gap-2 mt-3 pt-2 border-t border-slate-200">
        <button
          type="button"
          className="px-3 py-1 text-xs rounded border border-slate-300 hover:bg-slate-50"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          type="button"
          className="px-3 py-1 text-xs rounded bg-blue-600 text-white hover:bg-blue-700"
          onClick={onOk}
        >
          OK
        </button>
      </div>
    </div>
  );
});

export default MultiSelectEditor;
